const PRODUCTION_API_URL = `https://api.singhcoin.io`;
// "https://staging-api.singhcoin.io",
const STAGING_API_URL = `https://staging-api.singhcoin.io`;
const LOCAL_FRONTEND_URL = `http://localhost:3000`;
const PRODUCTION_FRONTEND_URL = `https://events.singhcoin.io`;

module.exports = {
  // baseUrl: "http://13.40.34.64:3001",
  // baseUrl: "https://api.singhcoin.io",
  // baseUrl: "http://35.179.2.23:3001",
  baseUrl: PRODUCTION_API_URL,
  redirectUrl: PRODUCTION_FRONTEND_URL,
};
